// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2no0S","footer":"ModalError_footer__Ilit3"};